// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { Leads } from './Leads';

/**
 * Utility intake — the AC source.
 *
 * A circle enclosing one sine cycle is the standard source symbol; the sine is
 * what separates it from a rotating machine, which carries a letter instead.
 * `FeederType` and `UtilityMeterType` both land here: from the diagram's point
 * of view they are the same thing, a source that nothing upstream feeds.
 */
export const UtilitySymbol = ({ size = 18, leads }: SymbolGlyphProps) => (
  <svg
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <Leads top={3.5} bottom={20.5} leads={leads} />
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth={GLYPH_STROKE} />
    <path
      d="M7.5 12 q2.25 -4 4.5 0 q2.25 4 4.5 0"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE}
      strokeLinecap="round"
    />
  </svg>
);
